export default {
  // default to a blank space
  content: "\u00A0"
};
